import { KeyboardEvent } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { InputGrid } from './InputGrid';
import { NewPasswordInput } from './NewPasswordInput';
import { TextInput } from './TextInput';

export type ChangePasswordModel = {
	password: string;
	newPassword: string;
	newPassword2: string;
	isValid: boolean;
};

type ChangePasswordInputProps = {
	model: ChangePasswordModel;
	onChange: (val: ChangePasswordModel) => void;
	onKeyPress: (event: KeyboardEvent<HTMLInputElement>) => void;
};
export const ChangePasswordInput = ({ model, onChange, onKeyPress }: ChangePasswordInputProps): JSX.Element => {
	const t = useTranslation().form;

	return (
		<InputGrid>
			<TextInput
				type="password"
				id="change-password"
				autocomplete="current-password"
				placeholder={t.password}
				value={model.password}
				onChange={(e) => onChange({ ...model, password: e.target.value })}
				autoFocus={true}
				onKeyDown={onKeyPress}
				nextElement="new-password"
			/>
			<NewPasswordInput
				model={model}
				onChange={(e) => onChange({ ...model, ...e })}
				onKeyPress={onKeyPress}
				fullWidth
			/>
		</InputGrid>
	);
};
